<template>
  <div class="toolbar">
    <div
      v-for="(button, index) in onlyVisibles(buttons)"
      v-bind:key="button.label"
      class="inlinebutton"
    >
      <drop
        @drop="handleDrop(button, ...arguments)"
        @dragenter="handleDragenter(button, ...arguments)"
        @dragover="handleDragover(button, ...arguments)"
        @dragleave="handleDragleave(button, ...arguments)"
      >
        <div
          class="dmdeskButtonContainer"
          v-bind:class="buttonContainerClass(button, index)"
        >
          <button
            class="dmdeskCategoryButtonClass"
            v-if="button.iconHead"
            v-bind:class="buttonClass(button, index)"
          >
            <span class="fa-stack fa-1x">
              <i class="fa fa-circle fa-stack-2x"></i>
              <i
                class="fa fa-lg fa-stack-1x fa-inverse"
                :class="button.iconHead"
              />
            </span>
          </button>
          <button
            class="dmdeskButton"
            v-else
            v-on:click="buttonFunction(button)"
            v-bind:disabled="button.isButtonDisabled == true"
            v-bind:title="$t(button.label)"
            v-bind:class="buttonClass(button, index)"
            @mouseover="onOverMainButton(button, ...arguments)"
          >
            <span v-if="button.icon && button.iconstack">
              <i
                class="fa fa-stack-1x"
                :class="[button.animate, button.icon]"
              />
              <i class="fa fa-stack-2x" :class="button.iconstack" />
            </span>
            <i
              v-if="button.icon && !button.iconstack"
              class="fa"
              :class="[button.animate, button.icon]"
            />
            {{ !button.icon ? $t(button.label) : "" }}
          </button>
          <button
            v-if="button.dropdown"
            class="dmdeskButtonExpand"
            @click="button.isDrop = !button.isDrop"
            @mouseover="onOverExpandButton(button, ...arguments)"
            @mouseleave="onLeave(button, ...arguments)"
          >
            <span class="caret"></span>
          </button>
          <ul
            v-if="button.dropdown"
            class="dropdownbuttons"
            v-bind:class="{ dropdownbuttonsvisible: button.isDrop }"
            v-bind:style="styles"
            @mouseover="onOverExpandButton(button, ...arguments)"
            @mouseleave="onLeave(button, ...arguments)"
          >
            <li
              v-for="dropbutton in button.dropdown"
              v-bind:key="dropbutton.label"
              class="inlinebutton"
            >
              <button
                class="dmdeskButton dmdeskButtonindropdown"
                v-on:click="buttonFunction(dropbutton)"
                v-bind:title="$t(dropbutton.label)"
                v-bind:class="dropButtonClass(dropbutton)"
                v-bind:disabled="dropbutton.isButtonDisabled == true"
              >
                <span
                  class="fa-stack"
                  v-if="dropbutton.icon && dropbutton.iconstack"
                >
                  <i
                    class="fa fa-stack-2x text-danger"
                    :class="dropbutton.iconstack"
                  />
                  <i class="fa fa-stack-1x" :class="dropbutton.icon" />
                </span>
                <i
                  v-if="dropbutton.icon && !dropbutton.iconstack"
                  class="fa"
                  :class="dropbutton.icon"
                />
                {{ $t(dropbutton.label) }}
                {{ getShortcut(dropbutton) }}
              </button>
            </li>
          </ul>
        </div>
      </drop>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Drop } from "vue-drag-drop";

const MacOS = "Mac OS";
const Windows = "Windows";

export default {
  name: "buttonstoolbar",
  components: {
    Drop
  },
  data: function () {
    return {
      hotKeys: [],
      isDropTarget: false,
      timeout: 0,
      os: "",
      styles: {
        left: "0px",
        top: "0px"
      }
    };
  },
  mounted: function () {
    const tmpthis = this;

    function checkButtons(buttons) {
      buttons.forEach(b => {
        if (b.isSelected == undefined) Vue.set(b, "isSelected", false);
        if (b.isDropTarget == undefined) Vue.set(b, "isDropTarget", false);
        if (b.canDrop == undefined) Vue.set(b, "canDrop", false);
        if (b.shortcut) {
          tmpthis.hotKeys.push(b);
        }
        if (b.dropdown) {
          checkButtons(b.dropdown);
        }
      });
    }
    checkButtons(this.buttons);
    if (tmpthis.hotKeys.length > 0) {
      document.addEventListener("keydown", this._keyListener);
    }
    this.os = this.getOS();
  },

  beforeDestroy() {
    if (this.hotKeys.length > 0) {
      document.removeEventListener("keydown", this._keyListener);
    }
  },

  computed: {},
  props: {
    disableHotKeys: {
      type: Boolean,
      default: false
    },

    buttons: {
      type: Array,
      default: function () {
        return [
          {
            label: "defaultButton",
            isDropTarget: false,
            isDrop: false,
            // eslint-disable-next-line
            call: test => {
              alert("Implement your own button");
            },
            isButtonDisabled: false,
            customClass: "",
            icon: "",
            animate: ""
          }
        ];
      }
    },
    config: {
      type: Object,
      default: function () {
        return {
          toolbarType: "left"
        };
      }
    }
  },
  methods: {
    getOS() {
      var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
        windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
        iosPlatforms = ["iPhone", "iPad", "iPod"],
        os = null;

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = MacOS;
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = "iOS";
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = Windows;
      } else if (/Android/.test(userAgent)) {
        os = "Android";
      } else if (!os && /Linux/.test(platform)) {
        os = "Linux";
      }

      return os;
    },

    _keyListener(e) {
      if (this.disableHotKeys) return;

      let element;
      if (e.target) {
        element = e.target;
      } else if (e.srcElement) {
        element = e.srcElement;
      }

      if (element.nodeType == 3) {
        element = element.parentNode;
      }

      if (element.tagName == "INPUT" || element.tagName == "TEXTAREA") return;

      this.hotKeys.forEach(b => {
        const k = b.shortcut;
        if (k) {
          let code;
          if (e.keyCode) code = e.keyCode;
          else if (e.which) code = e.which;
          let character = String.fromCharCode(code).toLowerCase();
          if (this.os == MacOS) {
            if (code == 8) {
              character = "del";
            } else if (
              code == 90 &&
              e.metaKey &&
              !e.altKey &&
              !e.shiftKey &&
              !e.ctrlKey
            ) {
              character = "undo";
            } else if (
              code == 90 &&
              e.metaKey &&
              !e.altKey &&
              e.shiftKey &&
              !e.ctrlKey
            ) {
              character = "redo";
            }
          } else if (this.os == Windows) {
            if (code == 46) {
              character = "del";
            } else if (
              code == 90 &&
              !e.metaKey &&
              !e.altKey &&
              !e.shiftKey &&
              e.ctrlKey
            ) {
              character = "undo";
            } else if (
              code == 91 &&
              !e.metaKey &&
              !e.altKey &&
              !e.shiftKey &&
              e.ctrlKey
            ) {
              character = "redo";
            }
          }
          /*
                    // console.log(code + '--'+ character);
                    if (e.ctrlKey) {
                        console.log('ctrl');
                    }
                    if (e.altKey) {
                        console.log('alt');
                    }
                    if (e.metaKey) {
                        console.log('meta');
                    }
                    if (e.shiftKey) {
                        console.log('shift');
                    }
                    */

          if (
            character === k.key &&
            ((!k.ctrl && !e.ctrlKey) || (k.ctrl && e.ctrlKey)) &&
            ((!k.alt && !e.altKey) || (k.alt && e.altKey)) &&
            ((!k.meta && !e.metaKey) || (k.meta && e.metaKey)) &&
            ((!k.shift && !e.shiftKey) || (k.shift && e.shiftKey))
          ) {
            if (!b.isButtonDisabled) {
              e.preventDefault();
              b.call(e);
            }
          }
        }
      });
    },
    getShortcut(button) {
      let short = "";
      if (button) {
        const k = button.shortcut;
        if (k) {
          short += " (";
          let character = k.key.toUpperCase();
          if (k.shift) {
            short += "Shift-";
          }
          if (k.ctrl) {
            short += "Ctrl-";
          }
          if (k.alt) {
            short += "Alt-";
          }
          if (k.meta) {
            short += "Meta-";
          }
          if (character) {
            short += character;
          }
          short += " )";
        }
      }
      return short;
    },

    // eslint-disable-next-line
    buttonContainerClass(button, index) {
      let bclass = {
        dmdeskButtonContainerStitch: this.isRightToolbar()
      };
      return bclass;
    },
    buttonClass(button, index) {
      let bclass = {
        dmdeskButtonselected: button.isSelected,
        quickbuttondrop: button.isDropTarget,
        dmdeskButtonwdropdown: button.dropdown,
        dmdeskButtonicon: button.icon,
        dmdeskButtonStitch: this.isRightToolbar(),
        dmdeskButtonFirst: index == 0 && this.isRightToolbar(),
        dmdeskButtonLast:
          index == this.buttons.length - 1 && this.isRightToolbar()
      };
      if (button.customClass && button.customClass.length > 0) {
        bclass[button.customClass] = true;
      }
      return bclass;
    },
    dropButtonClass(button) {
      let bclass = {
        dmdeskButtonselected: button.isSelected,
        quickbuttondrop: button.isDropTarget
      };
      if (button.customClass && button.customClass.length > 0) {
        bclass[button.customClass] = true;
      }
      return bclass;
    },
    isRightToolbar() {
      return this.config && this.config.toolbarType == "right";
    },
    buttonFunction(button) {
      // Some buttons can also be selected
      if (button.exclusive) {
        this.buttons.forEach(b => {
          b.isSelected = b == button && !!b.exclusive;
        });
      }
      let tmpthis = this;
      //setTimeout(function(){
      tmpthis.buttons.forEach(b => {
        Vue.set(b, "isDrop", false);
      });
      //}, 400);

      button.call(button);
    },
    // eslint-disable-next-line
    handleDrop(button, transferData, nativeEvent) {
      if (button.canDrop) {
        button.isDropTarget = false;
        this.$emit("toolbar-drop", transferData, button);
        /*if (!!button.exclusive) {
                    this.buttons.forEach (b => {
                        b.isSelected = ((b == button) && !!b.exclusive);
                    })
                }*/
      }
    },
    // eslint-disable-next-line
    async handleDragenter(button, transferData, nativeEvent) {
      if (button.canDrop) button.isDropTarget = true;
    },
    // eslint-disable-next-line
    async handleDragover(button, transferData, nativeEvent) {
      if (button.canDrop) button.isDropTarget = true;
    },
    // eslint-disable-next-line
    handleDragleave(button, transferData, nativeEvent) {
      if (button.canDrop) button.isDropTarget = false;
    },

    onOverExpandButton(button, event) {
      this.$emit("element-selected", this.elementToSelect);
      function offset(el) {
        const rect = el.getBoundingClientRect(),
          scrollLeft =
            window.pageXOffset || document.documentElement.scrollLeft,
          scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return {
          top: rect.bottom + scrollTop,
          left: rect.left + scrollLeft,
          bottom: rect.bottom + scrollTop,
          right: rect.right + scrollLeft
        };
      }
      const getMenu = el => {
        el = el.nextElementSibling;
        if (!el) {
          return undefined;
        }
        if (el.tagName == "UL") {
          return el;
        } else {
          return getMenu(el);
        }
      };

      Vue.set(button, "isDrop", true);
      const element = event.currentTarget;

      if (element.tagName == "BUTTON") {
        // The function is called also when the mouse hovers onto the dropdown list, so we need to check who originated the call
        const menuEl = getMenu(element);

        // Reset the height so that it will be recomputed
        menuEl.style.height = "auto";
        menuEl.style["overflow-y"] = "hidden";
        // We need to wait the next tick to ensure the menu has been displayed and dimensions have been computed
        this.$nextTick(() => {
          const buttonEl = element.previousElementSibling;
          var divOffset = offset(buttonEl);
          const menuRect = menuEl.getBoundingClientRect();

          let window_height = window.innerHeight;
          let window_width = window.innerWidth;
          if (divOffset.top + menuRect.height > window_height) {
            menuEl.style.height = window_height - divOffset.top + "px";
            menuEl.style["overflow-y"] = "scroll";
          }
          if (divOffset.left + menuRect.width > window_width) {
            divOffset.left = window_width - menuRect.width - 4;
            if (divOffset.left <= 0) {
              divOffset.left = 0;
            }
          }
          this.styles.top = divOffset.top + "px";
          this.styles.left = divOffset.left + "px";
        });
      }
      // Observe if parents are scrolled and in case close the menu
      /*let parentEl = this.$el.parentElement;
            while (parentEl) {
                let style = window.getComputedStyle(parentEl);
                if (style.overflow.includes('scroll') || style.overflow.includes('auto')) {
                    parentEl.addEventListener('scroll', () => { this.isDrop = false}, {once: true});
                }
                parentEl = parentEl.parentElement;
            }*/
      clearTimeout(button.timeout);
    },

    onOverMainButton() {
      this.buttons.forEach(b => {
        Vue.set(b, "isDrop", false);
      });
    },
    onLeave(button) {
      button.timeout = setTimeout(function () {
        Vue.set(button, "isDrop", false);
      }, 200);
    },

    onlyVisibles(buttons) {
      return buttons.filter(b => {
        return typeof b.isVisible !== "undefined" ? b.isVisible : true;
      });
    }
  }
};
</script>

<style lang="scss">
$round: 4px;

.dropdownbuttons {
  position: fixed;
  left: 0px;
  top: 100%;
  width: auto;
  display: none;
  z-index: 10;
  margin: 0px;
  padding: 4px;
  border-radius: $round;
  box-sizing: border-box;
  text-decoration: none;
  text-align: center;
  outline: none;
}

.dropdownbuttonsvisible {
  display: block;
}

.quickbutton,
.dmdeskButton {
  border-width: 0px;
  display: inline-block;
  margin-left: 2px;
  margin-right: 2px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 6px;
  border-radius: $round;
  box-sizing: border-box;
  text-decoration: none;
  text-align: center;
  position: relative;
  outline: none;
  background-color: white;
}

.dmdeskButtonStitch {
  border-width: 0px;
  margin-right: 0px;
  margin-left: 0px;
  border-radius: 0em;
}

.dmdeskButtonContainerStitch {
  margin-left: 0px !important;
  margin-right: -1px;
}

.dmdeskButtonFirst {
  margin-right: 0px;
  border-radius: $round 0em 0em $round;
}

.dmdeskButtonLast {
  margin-left: 0px;
  border-radius: 0em $round $round 0em;
}
.inlinebutton {
  display: block;
  white-space: nowrap;
}

.dmdeskButtonindropdown {
  width: 100%;
  margin: 2px 0px 2px 0px;
  padding-left: 12px;
  padding-right: 12px;
}

.dmdeskButtonwdropdown {
  padding-left: 10px;
  margin-right: 0px;
  border-right: 0px;
  border-radius: $round 0em 0em $round;
}

.dmdeskButtonicon {
  padding-left: 8px;
}

.dmdeskButtonContainer {
  position: relative;
  display: inline-block;
}

.dmdeskCategoryButtonClass {
  color: gray;
  border-width: 0px;
  background: none;
  padding: 0px;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.dmdeskButtonExpand {
  border-width: 0px;
  display: inline-block;
  margin-left: 0px;
  border-left: 0px;
  margin-right: 2px;
  padding-left: 4px;
  padding-right: 5px;
  padding-top: 6px;
  padding-bottom: 6px;
  border-radius: 0em $round $round 0em;

  box-sizing: border-box;
  text-decoration: none;
  text-align: center;
  position: relative;
  outline: none;
}

.quickbutton:hover,
.dmdeskButton:hover,
.dmdeskButtonExpand:hover {
  background-color: gainsboro;
}

.dmdeskButton:disabled {
  color: gray;
}
.dmdeskButton:disabled:hover {
  background-color: white;
}

.dmdeskButtonselected {
  background-color: gainsboro;
  box-shadow: inset 0 0.6em 2em -0.3em rgba(0, 0, 0, 0.15),
    inset 0 0 0em 0.05em rgba(255, 255, 255, 0.12);
}

.quickbuttondrop {
  background-color: darkgray;
}

.quickbutton {
  width: 24px;
}

div.inlinebutton {
  display: inline-block;
}

.text-danger {
  color: red;
  opacity: 0.4;
}
</style>
